// extracted by mini-css-extract-plugin
export default {"AnimatedStars":"AnimatedStars_AnimatedStars__cdblK","Star":"AnimatedStars_Star__LdlBg","star":"AnimatedStars_star__aUvjF"};